var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.994,
    height: 52.994,
    viewBox: "0 0 52.994 52.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 52.994,
    height: 52.994,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M4,0H48.994a4,4,0,0,1,4,4V48.994a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M7.714,26.206V22.889c7.339,0,16.855-10.881,17.126-13.034l3.315.037c0,3.765-11.351,16.314-20.441,16.314",
    fill: "#f8f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M7.714,26.061V23.032c7.531,0,17.082-11.267,17.269-13.161l3.029.02c0,3.732-11.272,16.17-20.3,16.17",
    fill: "#f8f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M45.28,26.061c-9.026,0-20.3-12.438-20.3-16.17h3.03c.186,1.874,9.737,13.141,17.268,13.141Z",
    fill: "#f8f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M25.646,13.323,12.438,23.9a1.337,1.337,0,0,0-.509,1.05v16.02A2.168,2.168,0,0,0,14.1,43.139H20.12A1.338,1.338,0,0,0,21.459,41.8V32.017A1.339,1.339,0,0,1,22.8,30.679h7.4a1.338,1.338,0,0,1,1.338,1.338v9.776a1.338,1.338,0,0,0,1.339,1.338H38.9a2.168,2.168,0,0,0,2.169-2.167V24.952a1.335,1.335,0,0,0-.522-1.051L27.335,13.322a1.341,1.341,0,0,0-1.689,0Z",
    fill: "#f8f3ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.aaed2c7d9e8ec324f45d719bede257f5.svg";
export { ForwardRef as ReactComponent };